import { getWordpressPost } from "@src/functions/wordpress";
import { wordpressPostIds } from "@src/constants/wordpress";
import WordpressPost from "../common/components/WordpressPost";

export async function getServerSideProps() {
  const postJson = await getWordpressPost(wordpressPostIds.terms);

  return {
    props: { data: Array.isArray(postJson) ? postJson[0] : postJson },
  }
}

function Post ({ data }: any) {
  return (
    <WordpressPost data={data} />
  );
};

export default Post;